import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { Auth0Provider } from "@auth0/auth0-react";
import { ThemeProvider } from "./context/ThemeContext";

const TITLE_VARIANTS = [
  {
    id: "a",
    value: "Value Draw | Lorcana price tracking & meta insights",
  },
  {
    id: "b",
    value: "Track Lorcana card prices & decks | Value Draw",
  },
];

const META_DESCRIPTION =
  "Monitor Lorcana card prices, deck performance, and market shifts with Value Draw’s real-time analytics and collection tools.";

const METADATA_KEYS = {
  description: { attr: "name", key: "description" },
  ogTitle: { attr: "property", key: "og:title" },
  ogDescription: { attr: "property", key: "og:description" },
  ogType: { attr: "property", key: "og:type" },
  twitterCard: { attr: "name", key: "twitter:card" },
  twitterTitle: { attr: "name", key: "twitter:title" },
  twitterDescription: { attr: "name", key: "twitter:description" },
};

const setMetaTag = (metaKey, content) => {
  const metaConfig = METADATA_KEYS[metaKey];
  const selector = `meta[${metaConfig.attr}="${metaConfig.key}"]`;
  let meta = document.querySelector(selector);

  if (!meta) {
    meta = document.createElement("meta");
    meta.setAttribute(metaConfig.attr, metaConfig.key);
    document.head.appendChild(meta);
  }

  meta.setAttribute("content", content);
};

const chooseTitleVariant = () => {
  const storageKey = "vd_meta_title_variant";
  const storedVariant = localStorage.getItem(storageKey);
  const nextVariant =
    storedVariant === "a" ? TITLE_VARIANTS[1] : TITLE_VARIANTS[0];

  localStorage.setItem(storageKey, nextVariant.id);
  return nextVariant;
};

const applySeoMetadata = () => {
  const { value: selectedTitle } = chooseTitleVariant();

  document.title = selectedTitle;
  setMetaTag("description", META_DESCRIPTION);
  setMetaTag("ogTitle", selectedTitle);
  setMetaTag("ogDescription", META_DESCRIPTION);
  setMetaTag("ogType", "website");
  setMetaTag("twitterCard", "summary_large_image");
  setMetaTag("twitterTitle", selectedTitle);
  setMetaTag("twitterDescription", META_DESCRIPTION);
};

applySeoMetadata();

// Create root element with document.getElementById for React 18
const container = document.getElementById("root");
const root = ReactDOM.createRoot(container);

// Render the app
root.render(
  <React.StrictMode>
    <Auth0Provider
      domain="login.valuedraw.com"
      clientId="2DNMkqKpJhOT8KDwjihGBKSlF04YKQ6r"
      authorizationParams={{
        redirect_uri: window.location.origin + "/card-analysis/",
        audience: "https://valuedraw.com/api/v1",
      }}
    >
      <ThemeProvider>
        <App />
      </ThemeProvider>
    </Auth0Provider>
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
